/**
 * Legacy NavigationApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.navigationApi`) keep resolving.
 *
 * The actual NavigationApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/navigation/navigation-api.service.ts
 */
angular.module("acme.common.service.navigationApi", []);
